import { createSlice } from '@reduxjs/toolkit';
import axios from 'src/utils/axios';

const initialState = {
  profile: {}
};

const endpoints = {
  getProfile(profileId) {
    return () => axios.get(`/profile/${profileId}`);
  },
  updateProfile(profileId) {
    return () => axios.put(`/profile/${profileId}`);
  }
};

const slice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    getProfile(state, action) {
      state.profile = action.payload;
    }
  }
});

export const reducer = slice.reducer;

export const getProfile = profileId => async dispatch => {
  try {
    let path = `/profile/${profileId ?? ''}`;
    const response = await axios.get(path);
    dispatch(slice.actions.getProfile(response.data));
  } catch (error) {
    console.log('slices > profile.js > getProfile', error);
  }
};
export const updateProfile = profile => async dispatch => {
  try {
    const response = await axios.put(`/profile/`, profile);
    // dispatch(slice.actions.getProfile(response.data.updatedProfile));
  } catch (error) {
    console.log('slices > reports.js > updateProfile', error);
  }
};

export default slice;
